import { PropsWithChildren, createContext, useContext, useRef, useState } from 'react';
import { toast } from 'sonner';

import { TOAST_DURATIONS } from 'lib/config/sonner';

type RobotArmLockedContextType = {
  locked: boolean;
  toggleArmLocked: VoidFunction;
  triggerArmLoggedToast: VoidFunction;
};

const RobotArmLockedContext = createContext<RobotArmLockedContextType | null>(null);

export function RobotArmLockedProvider({ children }: PropsWithChildren) {
  const [locked, setLocked] = useState<boolean>(true);
  const toastId = useRef<string | number | null>(null);

  function toggleArmLocked() {
    setLocked((prev) => !prev);
  }

  function triggerArmLoggedToast() {
    if (toastId.current) {
      toast.dismiss(toastId.current);
    }

    toastId.current = toast.error('Arm is locked - press Y to unlock', {
      duration: TOAST_DURATIONS.SHORT,
    });
  }

  return (
    <RobotArmLockedContext.Provider value={{ locked, toggleArmLocked, triggerArmLoggedToast }}>
      {children}
    </RobotArmLockedContext.Provider>
  );
}

/**
 * The robot arm have to manually be unlocked to prevent accidental movement
 */
export function useRobotArmLocked(): RobotArmLockedContextType {
  const context = useContext(RobotArmLockedContext);
  if (!context) {
    throw new Error('useRobotArmLocked must be used within a RobotArmLockedProvider');
  }
  return context;
}
